import React from 'react';
import TableComponent from '../../components/TableComponent';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import { filterTypeformSurveys } from '../../utils/miscFunctions';
import { compareDesc } from 'date-fns';

class ArchivedSurveys extends React.Component {
    constructor(props) {
        super();
        this.state = {
            surveys: [],
            page: 0,
            rowsPerPage: 10,
            searchTerm: '',
            totalSurveys: 0,
            pageCount: 0,
            paginatedSurveys: [],
            loading: true,
            loadingRest: true
        }
    }

    componentDidMount() {
        this.getSurveys();
    }

    // gets first page (n=100) of surveys from the archived workspace and sets the survey data to state
    // calls loadRest after setting state to load the remainder of the pages in the background
    getSurveys = async() => {
        this.setState({
            loading: true
        })
        const data = {
            page: this.state.page + 1,
            page_size: 100,
            workspace_id: process.env.REACT_APP_ARCHIVED_WORKSPACE
        }
        const body = {
            body: JSON.stringify(data),
            method: 'POST'
        }
        let answer = await fetch(`/.netlify/functions/typeform?type=getAll`, body).then(response =>
            response.json()
        ).catch(err => console.log("Failed to fetch all forms: ", err));
        if (answer && answer.status >= 200 && answer.status < 300) {
            let dataCopy = [...this.state.paginatedSurveys, ...answer.message.items];
            this.setState({
                surveys: answer.message.items,
                totalSurveys: answer.message.total_items,
                pageCount: answer.message.page_count,
                paginatedSurveys: dataCopy,
                loading: false
            }, ()=>{
                this.loadRest(answer.message.page_count);
            });
        } else {
            this.setState({
                loading: false
            });
        }
        console.log(answer);
    }

    // loads remainder of pages in the background after the first page loads
    loadRest = async (numPages) => {
        for(let index = 2; index <= numPages; index++){
            const data = {
                page: index,
                page_size: 100,
                workspace_id: process.env.REACT_APP_ARCHIVED_WORKSPACE
            }
            const body = {
                body: JSON.stringify(data),
                method: 'POST'
            }
            let answer = await fetch(`/.netlify/functions/typeform?type=getAll`, body).then(response =>
                response.json()
            ).catch(err => console.log("Failed to fetch all forms: ", err));
            if (answer && answer.status >= 200 && answer.status < 300) {
                let dataCopy = [...this.state.paginatedSurveys, ...answer.message.items];
                this.setState({
                    paginatedSurveys: dataCopy
                });
            }
        }
        this.setState({
            loadingRest: false
        })
    }

    updateState = (value, state) => {
        this.setState({
            [state]: value
        }, () => {
            if (state === 'searchTerm') {
                this.updateState(0, "page");
            }
        })
    }

    onRowClick = (data) => {
        const url = `/surveys/${data.id}`;
        this.props.history.push(url);
    }

    render() {
        const { searchTerm, rowsPerPage, page, totalSurveys, loading, loadingRest, paginatedSurveys } = this.state;
        let filteredSurveys = paginatedSurveys.filter(filterTypeformSurveys(searchTerm));
        filteredSurveys = filteredSurveys.sort((a, b) => compareDesc(new Date(a.last_updated_at), new Date(b.last_updated_at)));
        return (
            <div style={{ textAlign: 'center', position: 'relative', width: '100%' }}>
                <h2>Archived Surveys</h2>
                <Button onClick={()=>this.props.history.push('/surveys')} style={{ position: 'absolute', right: 30, top: 0, width: 150 }} variant="outlined" color="primary"> Active Surveys </Button>
                <TextField
                    id="search-input" variant="outlined"
                    value={searchTerm}
                    onChange={(e) => this.updateState(e.target.value, "searchTerm")}
                    InputProps={{ startAdornment: (<InputAdornment position="start"> <SearchIcon /> </InputAdornment>) }}
                    style={styles['search']}
                    autoComplete="off"
                    label="Search by ID or name"
                />
                {loadingRest &&
                    <p style={{ position: 'absolute', left: 10, top: 0, fontSize: 12 }}>{`${paginatedSurveys.length} surveys loaded / ${totalSurveys} total`}</p>
                }
                {(!loading && totalSurveys) ?
                    <TableComponent
                        data={filteredSurveys}
                        headers={["ID", "Name", "Last Updated", "Is Public"]}
                        fields={["id", "title", "last_updated_at", 'settings.is_public']}
                        updateState={this.updateState}
                        onRowClick={this.onRowClick}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        count={filteredSurveys.length}
                        type="surveys"
                    />
                    :
                    <p> {loading ? 'Loading data...' : 'No results found.' }</p>
                }
            </div>
        )
    }
}

const styles = {
    'search': {
        width: '50%',
        margin: 10
    },
}

export default ArchivedSurveys;